import React from 'react';
import classNames from 'classnames';
import styled from 'styled-components/macro';
import { SectionTitle } from '../elements/SectionTitle';

export interface NewsProps {
  id?: string;
  className?: string;
  children?: any;
}

export function NewsSection(props: NewsProps) {
  return (
    <Root id={props.id} className={classNames('section', props.className)}>
      <div className="container is-slim">
        <SectionTitle title="最新情報" caption="NEWS" />
        <div className="columns is-variable is-8 is-margin-top-2">
          <div className="column">
            <div className="card is-fullheight">
              <header className="card-header">
                <p className="card-header-title">
                  <span className="is-size-4 is-family-secondary">NEWS</span>
                  お知らせ
                </p>
              </header>
              <div className="card-content">
                <ul>{props.children}</ul>
              </div>
            </div>
          </div>
          <div className="column">
            <div className="card">
              <header className="card-header">
                <p className="card-header-title">
                  <span className="is-size-4 is-family-secondary">FOLLOW</span>
                  公式Twitter
                </p>
              </header>
              <div className="card-content">
                <a
                  className="twitter-timeline"
                  data-chrome="noheader nofooter noborders"
                  data-lang="ja"
                  href="https://twitter.com/MISSMRCOLLE?ref_src=twsrc%5Etfw"
                >
                  Tweets by MISSMRCOLLE
                </a>
              </div>
              <footer className="card-footer">
                <div className="card-footer-item">
                  <a className="button is-medium is-fullwidth is-twitter has-text-weight-bold" href="https://twitter.com/MISSMRCOLLE" target="_blank" rel="noopener">
                    <span className="icon">
                      <i className="fab fa-twitter" />
                    </span>
                    <span>フォローする</span>
                  </a>
                </div>
              </footer>
            </div>
          </div>
        </div>
      </div>
    </Root>
  );
}

const Root = styled.section`
  .card-header {
    margin-bottom: 2px;
  }
  .card-header-title {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
    justify-content: center;
    align-items: baseline;
    > * {
      margin: 0 1rem;
    }
  }
  .card-content {
    height: 320px;
    overflow-y: scroll;
    padding: 1rem;
  }

  .news-item {
    padding: 1rem 0;
    border-bottom: 2px solid #fafafa;
    &:first-child {
      padding-top: 0;
    }
  }
  .news-item-meta {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;
